import { CommonModule } from '@angular/common';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Overlay, OverlayConfig, OverlayModule } from '@angular/cdk/overlay';
import { Injectable, InjectionToken, Component, Inject, Output, EventEmitter, Input, Directive, HostListener, ViewContainerRef, Injector, NgModule, defineInjectable } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgBitsService = /** @class */ (function () {
    function NgBitsService() {
    }
    NgBitsService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    NgBitsService.ctorParameters = function () { return []; };
    /** @nocollapse */ NgBitsService.ngInjectableDef = defineInjectable({ factory: function NgBitsService_Factory() { return new NgBitsService(); }, token: NgBitsService, providedIn: "root" });
    return NgBitsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgBitsComponent = /** @class */ (function () {
    function NgBitsComponent() {
    }
    /**
     * @return {?}
     */
    NgBitsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    NgBitsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-ng-bits',
                    template: "\n    <p>\n      ng-bits works OK!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    NgBitsComponent.ctorParameters = function () { return []; };
    return NgBitsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CardComponent = /** @class */ (function () {
    function CardComponent() {
    }
    /**
     * @return {?}
     */
    CardComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CardComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-card',
                    template: "<div class=\"card card-box\">\n  <div class=\"card-header\">\n    <div class=\"card-title\">\n      <ng-content select=\"bit-card-title\"></ng-content>\n    </div>\n    <div class=\"card-subtitle\">\n      <ng-content select=\"bit-card-subtitle\"></ng-content>\n    </div>   \n  </div>\n  <div class=\"card-content\">\n    <ng-content select=\"bit-card-content\"></ng-content>\n  </div>\n  <div class=\"card-footer\">\n     <ng-content select=\"bit-card-footer\"></ng-content>\n  </div>\n</div>",
                    styles: [".card{border:1px solid #e8e8e8;background:#fff;border-radius:4px}.card-box{box-shadow:0 2px 1px -1px rgba(194,194,194,.5),0 1px 1px 0 rgba(194,194,194,.5),1px 1px 3px rgba(194,194,194,.5)}.card-header{padding:15px;border-bottom:1px solid #e8e8e8}.card-title{display:block;font-size:20px;margin-bottom:12px;color:#0f0f0f}.card-subtitle{display:block;font-size:14px;color:rgba(0,0,0,.54);margin-top:-8px}.card-content{margin:0;padding:15px;display:block;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;max-height:70vh;overflow:hidden;overflow-y:scroll}.card-footer{margin:0;text-align:right;display:block;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-direction:row;border-top:1px solid #e8e8e8;padding:15px}"]
                }] }
    ];
    /** @nocollapse */
    CardComponent.ctorParameters = function () { return []; };
    return CardComponent;
}());
/**
 * * Content ***
 */
var CardContent = /** @class */ (function () {
    function CardContent() {
    }
    CardContent.decorators = [
        { type: Directive, args: [{
                    selector: 'bit-card-content',
                    host: { 'class': 'card-content' }
                },] }
    ];
    return CardContent;
}());
/**
 * * Title ***
 */
var CardTitle = /** @class */ (function () {
    function CardTitle() {
    }
    CardTitle.decorators = [
        { type: Directive, args: [{
                    selector: 'bit-card-title, [bit-card-title]',
                    host: {
                        'class': 'card-title'
                    }
                },] }
    ];
    return CardTitle;
}());
/**
 * * Subtitle ***
 */
var CardSubtitle = /** @class */ (function () {
    function CardSubtitle() {
    }
    CardSubtitle.decorators = [
        { type: Directive, args: [{
                    selector: 'bit-card-subtitle, [bit-card-subtitle]',
                    host: {
                        'class': 'card-subtitle'
                    }
                },] }
    ];
    return CardSubtitle;
}());
/**
 * * Footer ***
 */
var CardFooter = /** @class */ (function () {
    function CardFooter() {
    }
    CardFooter.decorators = [
        { type: Directive, args: [{
                    selector: 'bit-card-footer',
                    host: {
                        'class': 'card-footer'
                    }
                },] }
    ];
    return CardFooter;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var TagComponent = /** @class */ (function () {
    function TagComponent() {
        this.bitOnClose = new EventEmitter();
    }
    /**
     * @return {?}
     */
    TagComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    TagComponent.prototype.onCloseClick = /**
     * @return {?}
     */
    function () {
        this.bitOnClose.emit();
    };
    TagComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-tag',
                    template: "<div class=\"tag\" [ngStyle]=\"{'background-color': bitColor}\" [ngClass]=\"{'tag-white': bitColor!=undefined}\">\n  <div class=\"tag-content\">\n    <ng-content>\n    </ng-content>\n  </div>\n  <div *ngIf=\"bitCloseable\" class=\"tag-icon\">\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\"/><path d=\"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z\"/></svg>\n  </div>\n</div>",
                    styles: [".tag{margin:0 5px 5px 0;padding:0 7px;display:inline-block;height:auto;font-size:14px;line-height:22px;white-space:nowrap;background:#f7f7f7;border:1px solid #e8e8e8;border-radius:4px;cursor:default;opacity:1;-webkit-transition:.3s;transition:.3s;color:rgba(0,0,0,.63)}.tag-content{display:inline-block}.tag-icon{padding:0;margin:0 0 0 3px;opacity:.71;width:14px;vertical-align:middle;display:inline-block;height:auto;line-height:14px}.tag-icon:hover{opacity:1}.tag-white{color:#fff;border-color:transparent}"]
                }] }
    ];
    /** @nocollapse */
    TagComponent.ctorParameters = function () { return []; };
    TagComponent.propDecorators = {
        bitCloseable: [{ type: Input }],
        bitColor: [{ type: Input }],
        bitOnClose: [{ type: Output }]
    };
    return TagComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ButtonComponent = /** @class */ (function () {
    function ButtonComponent() {
        this.bitType = 'default';
    }
    /**
     * @return {?}
     */
    ButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-button',
                    template: "<button [disabled] = \"disabled\" [ngClass] = \"{'button-normal': bitType=='default' || bitType=='danger' || bitType=='warning' || bitType=='success', 'button-border': bitType=='stroked', 'button-danger': bitType=='danger', 'button-warning': bitType=='warning', 'button-success': bitType=='success', 'button-link': bitType=='link', 'button-disabled': disabled}\">\n  <span class=\"button-content\"><ng-content></ng-content></span>  \n</button>",
                    styles: [".button-normal{background-color:#2379e3;color:#fff;box-sizing:border-box;position:relative;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;padding:0 14px;border-radius:4px;overflow:visible;height:32px;font-size:14px;font-weight:500;-webkit-transition:.2s cubic-bezier(.645,.045,.355,1);transition:.2s cubic-bezier(.645,.045,.355,1)}.button-normal:hover{background-color:#3782de}.button-normal.button-disabled{background-color:#e8e8e8;color:#bdbdbd;cursor:default}.button-raised{box-shadow:0 2px 4px 0 rgba(0,0,0,.25)}.button-danger{background-color:#f44336}.button-danger:hover{background-color:#ef5350}.button-warning{background-color:#fbc02d}.button-warning:hover{background-color:#fdd835}.button-success{background-color:#09af00}.button-success:hover{background-color:#41c300}.button-link{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;padding:0 14px;border-radius:4px;overflow:visible;height:32px;color:#2379e3;background:0 0;font-size:14px;font-weight:500;-webkit-transition:.2s cubic-bezier(.645,.045,.355,1);transition:.2s cubic-bezier(.645,.045,.355,1)}.button-link:hover{color:#3782de}.button-link.button-disabled{color:#bdbdbd;cursor:default}.button-border{background-color:transparent;color:#2379e3;box-sizing:border-box;position:relative;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;user-select:none;cursor:pointer;outline:0;border:1px solid #2379e3;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:64px;padding:0 14px;border-radius:4px;overflow:visible;height:32px;font-size:14px;font-weight:500;-webkit-transition:.2s cubic-bezier(.645,.045,.355,1);transition:.2s cubic-bezier(.645,.045,.355,1)}.button-border:hover{color:#3782de;border-color:#3782de}.button-border.button-disabled{color:#bdbdbd;border-color:#bdbdbd;cursor:default}.button-content::ng-deep #text:before{margin:0 5px}.button-content{-webkit-box-align:center;align-items:center}"]
                }] }
    ];
    /** @nocollapse */
    ButtonComponent.ctorParameters = function () { return []; };
    ButtonComponent.propDecorators = {
        bitType: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return ButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NoteComponent = /** @class */ (function () {
    function NoteComponent() {
        this.bitType = "info";
        this.bitShowIcon = true;
    }
    /**
     * @return {?}
     */
    NoteComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    NoteComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-note',
                    template: "<div class=\"note-container\" [ngClass]=\"{'note-warning': bitType=='warning', 'note-error': bitType=='error', 'note-success': bitType=='success', 'noIconPadding': !bitShowIcon}\">\n  <div class=\"icon icon-blue\" *ngIf=\"bitType=='info' && bitShowIcon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\"/><path d=\"M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z\" fill=\"currentColor\"/></svg>\n  </div>\n  <div class=\"icon icon-red\" *ngIf=\"bitType=='error' && bitShowIcon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\"><path opacity=\".87\" fill=\"none\" d=\"M0 0h24v24H0V0z\"/><path d=\"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.59-13L12 10.59 8.41 7 7 8.41 10.59 12 7 15.59 8.41 17 12 13.41 15.59 17 17 15.59 13.41 12 17 8.41z\" fill=\"currentColor\"/></svg>\n  </div>\n  <div class=\"icon icon-yellow\" *ngIf=\"bitType=='warning' && bitShowIcon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\"><path d=\"M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z\" fill=\"currentColor\"/></svg>\n  </div>\n  <div class=\"icon icon-green\" *ngIf=\"bitType=='success' && bitShowIcon\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"28\" height=\"28\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\"/><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z\" fill=\"currentColor\"/></svg>\n  </div>  \n  <span class=\"title\">{{bitTitle}}</span>\n  <span class=\"text\"><ng-content></ng-content></span>\n</div>",
                    styles: [".note-container{position:relative;display:block;margin:5px 0;padding:10px 10px 10px 60px;color:rgba(0,0,0,.65);line-height:1.5;border-radius:4px;border:1px solid #d2e2f9;background-color:#e5edf9}.noIconPadding{padding:10px!important}.note-error{border-color:#ffb0b4!important;background-color:#fcc!important}.note-success{background-color:#ddf7cc!important;border:1px solid #c5ec83!important}.note-warning{background-color:#fff4c8!important;border:1px solid #ffe26f!important}.title{font-size:16px;display:block;margin-bottom:5px}.text{font-size:14px;display:block}.icon{position:absolute;top:0;float:left;height:100%;left:16px;font-size:28px;-webkit-box-align:center;align-items:center;display:-webkit-inline-box;display:inline-flex}.icon-blue{color:#578fe4}.icon-red{color:#f56868}.icon-yellow{color:#f1c517}.icon-green{color:#83c511}"]
                }] }
    ];
    /** @nocollapse */
    NoteComponent.ctorParameters = function () { return []; };
    NoteComponent.propDecorators = {
        bitTitle: [{ type: Input }],
        bitType: [{ type: Input }],
        bitShowIcon: [{ type: Input }]
    };
    return NoteComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var DividerComponent = /** @class */ (function () {
    function DividerComponent() {
        this.bitOrientation = "left";
    }
    /**
     * @return {?}
     */
    DividerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    DividerComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-divider',
                    template: "<div class=\"divider\" [ngClass]= \"{'text-right': bitOrientation == 'right', 'text-left': bitOrientation == 'left', 'text-center': bitOrientation == 'center'}\">\n  <span><ng-content></ng-content></span>\n</div>",
                    styles: [".divider{display:table;margin:10px 0;color:#0f0f0f;white-space:nowrap;clear:both;width:100%;min-width:100%;height:1px;font-size:16px}.text-left::after{position:relative;display:table-cell;width:100%;border-top:1px solid #e8e8e8;content:'';top:10px}.text-left span{display:inline-block;padding-right:10px}.divider span:empty{padding:0}.text-right span{display:inline-block;padding-left:10px}.text-right::before{position:relative;display:table-cell;width:100%;border-top:1px solid #e8e8e8;content:'';top:10px}.text-center::after,.text-center::before{position:relative;display:table-cell;width:50%;border-top:1px solid #e8e8e8;content:'';top:10px}.text-center span{display:inline-block;padding:0 10px}"]
                }] }
    ];
    /** @nocollapse */
    DividerComponent.ctorParameters = function () { return []; };
    DividerComponent.propDecorators = {
        bitOrientation: [{ type: Input }]
    };
    return DividerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var CONTAINER_DATA = new InjectionToken('CONTAINER_DATA');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfirmationDialogComponent = /** @class */ (function () {
    function ConfirmationDialogComponent(componentData) {
        this.componentData = componentData;
        this.title = "Continue?";
        this.text = "Are you sure you want to continue?";
        this.confirmText = "OK";
        this.cancelText = "Cancel";
        this.onConfirm = new EventEmitter();
        this.onCancel = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (this.componentData.title != undefined) {
            this.title = this.componentData.title;
        }
        if (this.componentData.text != undefined) {
            this.text = this.componentData.text;
        }
        if (this.componentData.confirmText != undefined) {
            this.confirmText = this.componentData.confirmText;
        }
        if (this.componentData.cancelText != undefined) {
            this.cancelText = this.componentData.cancelText;
        }
    };
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.onOkClick = /**
     * @return {?}
     */
    function () {
        this.onConfirm.next();
    };
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.onCancelClick = /**
     * @return {?}
     */
    function () {
        this.onCancel.next();
    };
    ConfirmationDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-confirmation-dialog',
                    template: "<div class=\"container\">\n  <div class=\"confirm-title\">{{title}}</div>\n  <div class=\"confirm-text\">{{text}}</div>\n  <div class=\"confirm-footer\">\n    <div class=\"confirm-buttons\">\n      <bit-button bitType=\"link\" (click)=\"onCancelClick()\">{{cancelText}}</bit-button>\n      <bit-button (click)=\"onOkClick()\" cdkFocusInitial>{{confirmText}}</bit-button>\n    </div>\n  </div>\n</div>",
                    styles: [".confirm-footer{font-weight:700;text-align:right;width:100%;padding:0;margin-top:20px}.confirm-buttons{text-align:right;width:100%}.container{background:#fff;display:block;padding:20px;border-radius:4px;box-sizing:border-box;overflow:auto;outline:0;width:100%;min-width:300px;height:100%;min-height:inherit;max-height:inherit;box-shadow:0 4px 10px rgba(0,0,0,.2);color:rgba(0,0,0,.87)}.confirm-title{font-size:18px;font-weight:700;margin-bottom:10px}.confirm-text{font-size:15px}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}::ng-deep .cdk-overlay-dark-backdrop{background:rgba(0,0,0,.4)}::ng-deep .cdk-overlay-backdrop{position:absolute;top:0;bottom:0;left:0;right:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;-webkit-transition:opacity .3s cubic-bezier(.25,.8,.25,1);transition:opacity .3s cubic-bezier(.25,.8,.25,1);opacity:0}::ng-deep .cdk-overlay-container{position:fixed;z-index:1000;pointer-events:none;top:0;left:0;height:100%;width:100%}::ng-deep .cdk-global-overlay-wrapper{display:-webkit-box;display:flex;position:absolute;z-index:1000}::ng-deep .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:-webkit-box;display:flex;max-width:100%;max-height:100%}.cdk-overlay-container,::ng-deep .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}"]
                }] }
    ];
    /** @nocollapse */
    ConfirmationDialogComponent.ctorParameters = function () { return [
        { type: undefined, decorators: [{ type: Inject, args: [CONTAINER_DATA,] }] }
    ]; };
    ConfirmationDialogComponent.propDecorators = {
        onConfirm: [{ type: Output }],
        onCancel: [{ type: Output }]
    };
    return ConfirmationDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ConfirmDirective = /** @class */ (function () {
    function ConfirmDirective(overlay, viewContainerRef, injector) {
        this.overlay = overlay;
        this.viewContainerRef = viewContainerRef;
        this.injector = injector;
        this.bitEnable = true;
        this.bitCloseOnBackDrop = false;
        this.bitOnConfirm = new EventEmitter();
        this.bitOnCancel = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ConfirmDirective.prototype.onButtonClick = /**
     * @return {?}
     */
    function () {
        if (this.bitEnable) {
            this.openDialog();
        }
        else {
            this.bitOnConfirm.emit();
        }
    };
    /**
     * @return {?}
     */
    ConfirmDirective.prototype.openDialog = /**
     * @return {?}
     */
    function () {
        var _this = this;
        /** @type {?} */
        var config = new OverlayConfig({
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-dark-backdrop',
            positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically()
        });
        /** @type {?} */
        var overlayRef = this.overlay.create(config);
        /** @type {?} */
        var componentRef = overlayRef.attach(new ComponentPortal(ConfirmationDialogComponent, this.viewContainerRef, this.createPortalInjector({
            title: this.bitTitle,
            text: this.bitText,
            confirmText: this.bitConfirmText,
            cancelText: this.bitCancelText
        })));
        componentRef.instance.onConfirm.subscribe((/**
         * @return {?}
         */
        function () {
            _this.bitOnConfirm.emit();
            overlayRef.detach();
        }));
        componentRef.instance.onCancel.subscribe((/**
         * @return {?}
         */
        function () {
            _this.bitOnCancel.emit();
            overlayRef.detach();
        }));
        overlayRef.backdropClick().subscribe((/**
         * @return {?}
         */
        function () {
            if (_this.bitCloseOnBackDrop) {
                _this.bitOnCancel.emit();
                overlayRef.detach();
            }
        }));
    };
    /**
     * @param {?} dataToPass
     * @return {?}
     */
    ConfirmDirective.prototype.createPortalInjector = /**
     * @param {?} dataToPass
     * @return {?}
     */
    function (dataToPass) {
        /** @type {?} */
        var injectorTokens = new WeakMap();
        injectorTokens.set(CONTAINER_DATA, dataToPass);
        return new PortalInjector(this.injector, injectorTokens);
    };
    ConfirmDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[bitConfirm]'
                },] }
    ];
    /** @nocollapse */
    ConfirmDirective.ctorParameters = function () { return [
        { type: Overlay },
        { type: ViewContainerRef },
        { type: Injector }
    ]; };
    ConfirmDirective.propDecorators = {
        bitEnable: [{ type: Input }],
        bitTitle: [{ type: Input }],
        bitText: [{ type: Input }],
        bitConfirmText: [{ type: Input }],
        bitCancelText: [{ type: Input }],
        bitCloseOnBackDrop: [{ type: Input }],
        bitOnConfirm: [{ type: Output }],
        bitOnCancel: [{ type: Output }],
        onButtonClick: [{ type: HostListener, args: ['click',] }]
    };
    return ConfirmDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var CountComponent = /** @class */ (function () {
    //add on text click and on value click
    function CountComponent() {
    }
    /**
     * @return {?}
     */
    CountComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    CountComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-count',
                    template: "<div class=\"bit-count-table\">\n  <div class=\"bit-count-column bit-count-left\" [ngClass]=\"{'bit-count-left-box': bitStyle=='box'}\">\n    <span>\n      <!-- <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\"><path fill=\"none\" d=\"M0 0h24v24H0V0z\"/><path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z\" fill=\"currentColor\"/></svg> -->\n      <ng-content select=\"bit-icon-content\"></ng-content>\n    </span>\n    {{bitText}}\n  </div>\n  <div class=\"bit-count-column bit-count-right\" [ngClass]=\"{'bit-count-right-box': bitStyle=='box'}\"><span>{{bitValue}}</span></div>\n</div>",
                    styles: [".bit-count-table{margin:0 5px 5px 0;display:inline-block}.bit-count-column{display:block}.bit-count-column span ::ng-deep bit-icon-content{display:-webkit-inline-box;display:inline-flex}.bit-count-left{float:left;-webkit-box-align:center;align-items:center;padding:8px 4px 8px 10px;position:relative;font-size:14px;white-space:nowrap;vertical-align:middle;border-radius:4px 0 0 4px}.bit-count-left-box{background-color:#f7f7f7;border:1px solid #e8e8e8;font-weight:700;padding-right:10px}.bit-count-left span{margin-right:3px;float:left;-webkit-box-align:center;align-items:center;display:-webkit-inline-box;display:inline-flex}.bit-count-right{float:left;padding:8px 10px 8px 0;font-size:14px;vertical-align:middle;border-top-right-radius:4px;border-bottom-right-radius:4px}.bit-count-right span{border-radius:18px;background:#e8e8e8;padding:1px 6px}.bit-count-right-box{border:1px solid #e8e8e8;font-weight:700;padding-left:10px;background:#fff;border-left:0}.bit-count-right-box span{border:none;background:0 0}"]
                }] }
    ];
    /** @nocollapse */
    CountComponent.ctorParameters = function () { return []; };
    CountComponent.propDecorators = {
        bitText: [{ type: Input }],
        bitValue: [{ type: Input }],
        bitStyle: [{ type: Input }]
    };
    return CountComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var IconContentComponent = /** @class */ (function () {
    function IconContentComponent() {
    }
    /**
     * @return {?}
     */
    IconContentComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    IconContentComponent.decorators = [
        { type: Component, args: [{
                    selector: 'bit-icon-content',
                    template: "<ng-content>\n</ng-content> ",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    IconContentComponent.ctorParameters = function () { return []; };
    return IconContentComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgBitsModule = /** @class */ (function () {
    function NgBitsModule() {
    }
    NgBitsModule.decorators = [
        { type: NgModule, args: [{
                    entryComponents: [ConfirmationDialogComponent],
                    declarations: [NgBitsComponent, CardComponent, CardTitle, CardSubtitle, CardContent, CardFooter, TagComponent, ButtonComponent, NoteComponent, DividerComponent, ConfirmationDialogComponent, ConfirmDirective, CountComponent, IconContentComponent],
                    imports: [CommonModule, OverlayModule],
                    exports: [NgBitsComponent, CardComponent, CardTitle, CardSubtitle, CardContent, CardFooter, TagComponent, ButtonComponent, NoteComponent, DividerComponent, ConfirmationDialogComponent, ConfirmDirective, CountComponent, IconContentComponent]
                },] }
    ];
    return NgBitsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgBitsService, NgBitsComponent, NgBitsModule, CardComponent, CardContent, CardTitle, CardSubtitle, CardFooter, TagComponent, ButtonComponent, NoteComponent, DividerComponent, CountComponent, IconContentComponent, ConfirmDirective, CONTAINER_DATA as ɵb, ConfirmationDialogComponent as ɵa };

//# sourceMappingURL=ng-bits.js.map